import { Lock, SecurityCard } from "iconsax-react";
import { Banknote, CheckCircle } from "lucide-react";

const FeatureSection = () => {
  return (
    <section className="w-full py-16 px-6 md:px-16 flex flex-col items-center bg-gray-50">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 w-full max-w-7xl">
          <div className="flex flex-row   gap-3">
            <Banknote color="#32AE4C" variant="Bold" size={24}  />
          <div>
          <h3 className="text-xl font-semibold mb-3">Easy Transactions</h3>
          <p className="text-gray-600">Send and receive money instantly with zero fees. Quick transfers to anyone, anywhere.</p>
        </div>
        </div>
        
        <div className="flex flex-row   gap-3">
            <Lock color="#32AE4C" variant="Bold" size={24}  />
          <div>

             <h3 className="text-lg md:text-xl font-semibold mb-3">Track your Funds</h3>
          <p className="text-gray-600">Get a complete overview of your spending habits and manage your budget effectively.</p>
          </div>
         
        </div>
        
          <div className="flex flex-row   gap-3">
            <SecurityCard color="#32AE4C" variant="Bold" size={24} />
          <div>
          <h3 className="text-lg md:text-xl font-semibold mb-3">Safe and Secure</h3>
          <p className="text-gray-600">Bank-level security to keep your money and personal information protected at all times.</p>
        </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;